import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import Select from 'components/CustomSelect/Select';
import ModalButton from 'components/CustomButtons/Button';
import Addresses from 'views/Clients/FormTabs/Addresses/List';
import { orderStyles } from 'views/Orders/styles';
import Close from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MaterialButton from '@material-ui/core/Button';
import { navyColor } from 'assets/jss/material-dashboard-pro-react';
import { makeStyles } from '@material-ui/styles';

import DELIVERY_TYPES from '../../consts/deliveryTypes';

const useStyles = makeStyles({
  wrapper: {
    alignItems: 'center',
    marginTop: '15px',
    justifyContent: 'space-between',
    '@media (min-width: 1850px)': {
      display: 'flex',
    },
  },
  items: {
    marginTop: '15px',
    '@media (min-width: 1850px)': {
      width: '60%',
      marginTop: '0',
      marginLeft: '15px',
    },
  },

  addNewAddress: {
    marginTop: '15px',
    color: navyColor,
    borderColor: navyColor,
  },
});

const DeliveryAddressSection = ({
  diet = {},
  classes: propClasses,
  pickUpPoints = [],
  deliveryTypes,
  deliveryType,
  setDeliveryType,
  selectedCustomer = {},
  customerAddresses = [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  updateDiet = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  updateCustomerAddresses = () => {},
}) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const { address, pickUpPoint } = diet ?? {};

  const [isNewAddressDialogOpened, setIsNewAddressDialogOpened] =
    useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define -- FIXME
    setFirstAvailableOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [deliveryType]);

  const setFirstAvailableOption = () => {
    if (deliveryType?.value === DELIVERY_TYPES.ADDRESS) {
      updateDiet({
        ...diet,
        pickUpPoint: null,
        address: isEmpty(customerAddresses)
          ? null
          : // eslint-disable-next-line no-shadow -- FIXME
            customerAddresses.find(address => address.isDefault) ??
            customerAddresses[0],
      });
    }

    if (deliveryType?.value === DELIVERY_TYPES.PICK_UP_POINT) {
      updateDiet({
        ...diet,
        pickUpPoint: isEmpty(pickUpPoints) ? null : pickUpPoints[0],
        address: null,
      });
    }
  };

  return (
    <div>
      <div className={classes.wrapper}>
        <p className={propClasses.labelBlack}>
          {t('orders.deliveryType', '$$Typ dostawy')}
        </p>
        <div className={classes.items} data-cy="delivery_section-delivery-type">
          <Select
            label={t('orders.select', '$$Wybierz')}
            value={deliveryType}
            options={deliveryTypes.filter(el => Object.keys(el).length > 0)}
            handleChange={setDeliveryType}
          />
        </div>
      </div>
      {deliveryType?.value === DELIVERY_TYPES.PICK_UP_POINT && (
        <div className={classes.wrapper}>
          <p className={propClasses.labelBlack}>
            {t('orders.choosePickUpPoint', '$$Wybierz punkt odbioru')}
          </p>
          <div
            className={classes.items}
            data-cy="delivery_section-pickup_point"
          >
            <Select
              label={t('orders.select', '$$Wybierz')}
              value={pickUpPoint}
              options={pickUpPoints}
              handleChange={option => {
                updateDiet({
                  ...diet,
                  pickUpPoint: option,
                  address: null,
                });
              }}
            />
          </div>
        </div>
      )}
      {deliveryType?.value === DELIVERY_TYPES.ADDRESS && (
        <>
          {!isEmpty(customerAddresses) && (
            <div className={classes.wrapper}>
              <p className={propClasses.labelBlack}>
                {t('orders.chooseAddress', '$$Wybierz adres')}
              </p>
              <div className={classes.items}>
                <Select
                  data-cy="delivery_section-choice-address"
                  label={t('orders.select', '$$Wybierz')}
                  value={address}
                  options={customerAddresses}
                  handleChange={option => {
                    updateDiet({
                      ...diet,
                      pickUpPoint: null,
                      address: option,
                    });
                  }}
                />
              </div>
            </div>
          )}
          <MaterialButton
            className={classes.addNewAddress}
            data-cy="delivery_section-add-new-address"
            variant="outlined"
            fullWidth={true}
            onClick={() => setIsNewAddressDialogOpened(true)}
          >
            + {t('orders.addNewAddress', 'Dodaj nowy adres')}
          </MaterialButton>
        </>
      )}
      {isNewAddressDialogOpened ? (
        <Dialog
          maxWidth="lg"
          fullWidth={true}
          open={isNewAddressDialogOpened}
          onClose={() => {
            setIsNewAddressDialogOpened(false);
            updateCustomerAddresses();
          }}
        >
          <DialogContent>
            <ModalButton
              style={orderStyles.closeButton}
              color="transparent"
              justIcon={true}
              round={true}
              onClick={() => {
                setIsNewAddressDialogOpened(false);
                updateCustomerAddresses();
              }}
            >
              <Close />
            </ModalButton>
            <Addresses
              noCancel={true}
              userId={selectedCustomer?.id}
              isChangeUrlLoader={false}
            />
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
};

export default DeliveryAddressSection;
